module.exports = __webpack_public_path__ + "media/images/client-neighborly-5d7e319647b89960bad8ffb5f0541860.png";